// extracted by mini-css-extract-plugin
export default {"clientMessageTab":"MessagesTab_clientMessageTab__wjUNR"};